import { Behaviour, serializable } from "@needle-tools/engine";
import { WheelRotation } from "./WheelRotation";

export class WheelController extends Behaviour {
  
    @serializable(WheelRotation)
    public wheelRotationArray: WheelRotation[] = [];
  
    start(): void {
    this.rotateWheels(false);
  }

  public rotateWheels(rotate : boolean) {
    
    for (let i = 0; i < this.wheelRotationArray.length; i++) {
      this.wheelRotationArray[i].enabled = rotate;
    }
  }

}